import React, { useContext } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { AppState } from 'services/types';
import ActiveTableCellRowCheckbox from 'components/ActiveTableCellRowCheckbox';
import {
    VirtualizedTableColumnKeys,
    VirtualizedTableItemKey
} from 'services/virtualizedTable/types';
import { selectVirtualizedTableColumnKeys } from 'services/virtualizedTable/selectors';

import { VirtualizedTableContextProviderValue } from '../../types';
import {
    ROW_HEIGHT,
    SELECT_COLUMN_WIDTH,
    EXPAND_COLUMN_WIDTH,
    FILLER_COLUMN_WIDTH
} from '../../constants';
import VirtualizedTableContext from '../VirtualizedTableContext';
import VirtualizedTableHeaderColumn from '../VirtualizedTableHeaderColumn';
import { selectItemKeys } from '../../selectors';

interface ConnectedProps {
    columnKeys: VirtualizedTableColumnKeys;
    itemKeys: VirtualizedTableItemKey[];
}

type Props = ConnectedProps;

export const VirtualizedTableHeaderComponent = (
    props: Props
): React.ReactElement => {
    const { columnKeys, itemKeys } = props;

    const {
        selectable,
        onExpand,
        enableItemEditing
    }: VirtualizedTableContextProviderValue = useContext(
        VirtualizedTableContext
    );

    const isExpandable = onExpand || enableItemEditing;

    return (
        <div
            className="virtualized-table-header"
            style={{
                height: ROW_HEIGHT
            }}
        >
            <div className="virtualized-table-header-row">
                {selectable && (
                    <div
                        className="virtualized-table-header-cell select"
                        style={{
                            width: SELECT_COLUMN_WIDTH,
                            height: ROW_HEIGHT
                        }}
                    >
                        <ActiveTableCellRowCheckbox rowId={itemKeys} />
                    </div>
                )}
                {isExpandable && (
                    <div
                        className="virtualized-table-header-cell expand"
                        style={{
                            width: EXPAND_COLUMN_WIDTH,
                            height: ROW_HEIGHT
                        }}
                    />
                )}
                {columnKeys &&
                    columnKeys.map((columnKey) => (
                        <VirtualizedTableHeaderColumn
                            key={columnKey}
                            columnKey={columnKey}
                        />
                    ))}

                <div
                    className="virtualized-table-header-cell"
                    style={{
                        width: FILLER_COLUMN_WIDTH,
                        height: ROW_HEIGHT
                    }}
                />
            </div>
        </div>
    );
};

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    columnKeys: selectVirtualizedTableColumnKeys,
    itemKeys: selectItemKeys
});

export default connect(mapStateToProps)(VirtualizedTableHeaderComponent);
